// extracted by mini-css-extract-plugin
module.exports = {"teamInvite":"TeamInvite_teamInvite___utGb"};